//
// IMPORTS
//

// Base URL for the API
import { reportUrl } from '@/constants'

import { httpRequest } from '@/services/api'

//
//
//
// ENDPOINTS E FUNÇÕES PARA RELATÓRIOS
//
//
//

const apiCheckReportStatus = endpointAddress => httpRequest({ method: 'GET', url: `${reportUrl}/${endpointAddress}` })

const apiOpenReport = (generateUrl, complete = false) => window.open(complete ? generateUrl : `${reportUrl}/${generateUrl}`)

//
//
//
// SAÍDA
//
//
//

export {
  apiCheckReportStatus,
  apiOpenReport,
}
